import React, { PureComponent } from 'react';
import ReactDataSheet from 'react-datasheet';
import { CarModelModel } from '../../api/core/core.types';
import { RateModel, RatePlanModel, RatePlanPeriodModel } from '../../api/pricing/pricing.types';
import { getRateTableColumns } from '../../helpers/rateplan.helper';
import SheetRenderer, { CellRenderer, GridElement } from './DataSheet';

interface RatePlanDetailTableViewProps {
  selectedRatePlan?: RatePlanModel;
  carModels: CarModelModel[];
  ratePlanPeriods: RatePlanPeriodModel[];
}

interface RatePlanDetailTableViewState {
  grid: GridElement[][];
  columns: {label: string; width: string}[];
}

export class RatePlanDetailTableView extends PureComponent<RatePlanDetailTableViewProps, RatePlanDetailTableViewState> {

  readonly state = {
    grid: [],
    columns: []
  };

  componentDidMount() {
    if (this.props.ratePlanPeriods.length !== 0) this.assignColumns(this.props.ratePlanPeriods);
    if (this.props.selectedRatePlan) this.assignRatesToTableGrid(this.props.selectedRatePlan);
  }

  componentDidUpdate(prevProps: RatePlanDetailTableViewProps) {
    if (!this.state.columns.length && this.props.ratePlanPeriods.length) {
      this.assignColumns(this.props.ratePlanPeriods);
    }

    if (prevProps.selectedRatePlan !== this.props.selectedRatePlan) {
      if (this.props.selectedRatePlan) this.assignRatesToTableGrid(this.props.selectedRatePlan);
    }
  }

  assignColumns = (ratePlanPeriods: RatePlanPeriodModel[]) => {
    const columns = getRateTableColumns(ratePlanPeriods, false);

    this.setState({ columns });
  };

  getCarModelName = (carModelId: number) => {
    const carModel = this.props.carModels.find((cm) => cm.id === carModelId);
    if (carModel) return carModel.name;

    return String(carModelId);
  };

  getRateMatrix = (ratePlan: RatePlanModel) => {
    const rates = ratePlan.rates.sort((a: RateModel, b: RateModel) => a.rowNumber - b.rowNumber);
    const ratesMatrix: RateModel[][] = [ [] ];

    let rowNumber = 1;
    let activeRow = 1;
    rates.forEach((rate) => {
      if (rate.rowNumber !== rowNumber) {
        rowNumber = rate.rowNumber;
        activeRow++;
        ratesMatrix.push([ rate ]);
      } else ratesMatrix[activeRow - 1].push(rate);
    });

    return ratesMatrix;
  };

  assignRatesToTableGrid = (ratePlan: RatePlanModel) => {
    if (ratePlan.rates.length) {
      const ratesMatrix = this.getRateMatrix(ratePlan);
      const grid: GridElement[][] = [];

      ratesMatrix.forEach((row) => {
        if (row.length) {
          const gridRow = [ { value: row[0].carModelInfo.acrissCode, readOnly: true }, { value: this.getCarModelName(row[0].carModelInfo.carModelId), readOnly: true } ];

          this.props.ratePlanPeriods.forEach((rpp) => {
            const rate = row.find((r) => r.ratePlanPeriod.daysFrom === rpp.daysFrom);

            if (rate) gridRow.push({ value: String(rate.baseAmount), readOnly: false });
            else gridRow.push({ value: String(''), readOnly: false });
          });

          grid.push(gridRow);
        }
      });

      this.setState({ grid });
    }
  };

  renderSheet = (props: any) => <SheetRenderer columns={this.state.columns} {...props} />;

  renderCells = (props: any) => <CellRenderer isReadonly readOnly {...props} />;

  render() {
    return (
      <>
        <main>
          {this.props.selectedRatePlan && this.props.selectedRatePlan.rates.length !== 0 && (
            <ReactDataSheet
              data={this.state.grid}
              valueRenderer={(cell: any) => cell.value}
              sheetRenderer={this.renderSheet}
              cellRenderer={this.renderCells}
            />
          )}
        </main>
      </>
    );
  }

}
